Wee.fn.extend('commerce', {
	/**
	 * Quantity selector
	 *
	 * @param {object} [options]
	 * @param {string} [options.disabledClass=-is-disabled]
	 * @param {string} [options.formSelector=ref:updateQtyForm]
	 * @param {boolean} [options.ajax=false]
	 * @param {number} [options.timer=1000]
	 * @param {(Array|function|string)} [options.success] - callback if request succeeds
	 * @param {(Array|function|string)} [options.error] - callback if request fails
	 */
	initQtySelector: function(options) {
		var priv = this.$private;

		priv.settings = $.extend({
			disabledClass: '-is-disabled',
			formSelector: 'ref:updateQtyForm',
			ajax: false,
			timer: 1000
		}, options);

		priv.initQtyEvents();
	},

	/**
	 * Destroy quantity selector
	 */
	destroyQtySelector: function() {
		$.events.off(false, '.commerceQty');
	}
}, {
	/**
	 * Init quantity events
	 *
	 * @private
	 */
	initQtyEvents: function() {
		var scope = this;

		$.events.on({
			'ref:quantitySubtract': {
				click: function() {
					scope.toggleQty($(this), false);
				}
			},
			'ref:quantityAdd': {
				click: function() {
					scope.toggleQty($(this), true);
				}
			},
			'ref:quantityValue': {
				change: function(e, el) {
					var $el = $(el);

					scope.updateQtyBtnStates($el.closest('ref:quantity'));

					if (! scope.qtyReset && scope.settings.ajax) {
						scope.updateCartQty($el);
					}
				}
			}
		}, {
			namespace: 'commerceQty'
		});
	},

	/**
	 * Update cart quantity
	 *
	 * @private
	 * @param {object} el
	 */
	updateCartQty: function(el) {
		var scope = this,
			$input = $(el),
			settings = scope.settings,
			successCallback = settings.success,
			errorCallback = settings.error;

		clearTimeout(scope.qtyTimer);

		scope.qtyTimer = setTimeout(function() {
			scope.post({
				data: $input.closest(settings.formSelector).serialize(),
				success: function(response) {
					if (response.success) {
						if ($input.data('qty')) {
							$input.data('qty', $input.val());
						}

						$.set('cart', scope.transform(response.cart));

						if (successCallback) {
							successCallback(response);
						}
					} else {
						scope.resetQtySelector($input);

						if (errorCallback) {
							errorCallback(response);
						}
					}
				},
				error: function(response) {
					scope.resetQtySelector($input);

					if (errorCallback) {
						errorCallback(response);
					}
				}
			});
		}, settings.timer);
	},

	/**
	 * Reset quantity selector to its original value
	 *
	 * @private
	 * @param {object} el
	 */
	resetQtySelector: function(el) {
		var $input = $(el),
			attr = $input.data('qty');

		if (attr) {
			this.qtyReset = true;

			$input.val(attr)
				.trigger('change');

			this.qtyReset = false;
		}
	},

	/**
	 * Check if quantity is less than max
	 *
	 * @private
	 * @param {number} value
	 * @param {number} max
	 * @return {boolean}
	 */
	canIncrease: function(value, max) {
		return max ? value < max : true;
	},

	/**
	 * Determine if quantity is greater than one or min
	 *
	 * @private
	 * @param {number} value
	 * @param {number} min
	 * @return {boolean}
	 */
	canDecrease: function(value, min) {
		return (min ? value > min : true) && value > 1;
	},

	/**
	 * Update the input quantity
	 *
	 * @private
	 * @param {object} element
	 * @param {boolean} increase
	 */
	toggleQty: function(element, increase) {
		var $container = $(element).closest('ref:quantity'),
			$input = $container.find('ref:quantityValue'),
			value = parseInt($input.val());

		if (increase) {
			if (this.canIncrease(value, parseInt($input.attr('max')))) {
				$input.val(++value)
					.trigger('change');
			}
		} else {
			if (this.canDecrease(value, parseInt($input.attr('min')))) {
				$input.val(--value)
					.trigger('change');
			}
		}
	},

	/**
	 * Update quantity button states
	 *
	 * @private
	 * @param {object} $container
	 */
	updateQtyBtnStates: function($container) {
		var $input = $container.find('ref:quantityValue'),
			$minusBtn = $container.find('ref:quantitySubtract'),
			$plusBtn = $container.find('ref:quantityAdd'),
			value = parseInt($input.val());

		this.canDecrease(value, parseInt($input.attr('min'))) ?
			this.enableQtyBtn($minusBtn) :
			this.disableQtyBtn($minusBtn);

		this.canIncrease(value, parseInt($input.attr('max'))) ?
			this.enableQtyBtn($plusBtn) :
			this.disableQtyBtn($plusBtn);
	},

	/**
	 * Disable button
	 *
	 * @private
	 * @param {object} $btn
	 */
	disableQtyBtn: function($btn) {
		$btn.prop('disabled', true)
			.addClass(this.settings.disabledClass);
	},

	/**
	 * Enable button
	 *
	 * @private
	 * @param {object} $btn
	 */
	enableQtyBtn: function($btn) {
		$btn.prop('disabled', false)
			.removeClass(this.settings.disabledClass);
	}
});
